import React from "react";
import styles from "./GalleryPage.module.css";
import { useNavigate } from "react-router-dom";

const sections = [
  {
    title: "Newsletter",
    key: "newsletter",
    imageUrl: "/images/Newsletter_thumbnail.jpg",
  },
  {
    title: "Advertorial",
    key: "advertorial",
    imageUrl: "/images/Advertorial_thumbnail.jpg",
  },
  {
    title: "Booklet",
    key: "booklet",
    imageUrl: "/images/MIning_tourism_thumbnail.jpg",
  },
  { title: "Brochure", key: "brochure", imageUrl: "/images/unsplash3.jpg" },
];

function GalleryPage() {
  const navigate = useNavigate();

  return (
    <section className={styles.gallerySection}>
      <div className={styles.bannerContainer}>
        <img
          src="/images/unsplash7.jpg"
          alt="preview"
          className={styles.bannerImage}
        />
        <h2 className={styles.bannerText}>MEDIA VAULT</h2>
      </div>
      <div className={styles.galleryContainer}>
        {sections.map((section) => (
          <div
            key={section.key}
            className={styles.card}
            onClick={() => navigate(`/gallery-section/${section.key}`)}
          >
            <div
              className="position-relative overflow-hidden"
              style={{
                cursor: "pointer",
                borderRadius: "8px",
                boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                overflow: "hidden",
                height: "400px",
                width: "100%",
              }}
              onMouseEnter={(e) => {
                const img = e.currentTarget.querySelector("img");
                const overlay = e.currentTarget.querySelector(".overlay");
                img.style.transform = "scale(1.05)";
                overlay.style.opacity = 1;
              }}
              onMouseLeave={(e) => {
                const img = e.currentTarget.querySelector("img");
                const overlay = e.currentTarget.querySelector(".overlay");
                img.style.transform = "scale(1)";
                overlay.style.opacity = 0;
              }}
            >
              <div className={styles.ribbon}>{section.title}</div>
              <img
                src={section.imageUrl}
                alt={`Gallery ${section.title}`}
                className="w-100 h-100"
                style={{
                  objectFit: "cover",
                  transition: "transform 0.3s ease",
                }}
              />
              {/* Overlay */}
              <div
                className="overlay position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
                style={{
                  background: "rgba(0,0,0,0.3)",
                  color: "#edececff",
                  fontSize: "3rem",
                  fontWeight: "700",
                  fontStyle: "italic",
                  opacity: 0,
                  transition: "opacity 0.3s ease",
                }}
              >
                {section.title}
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default GalleryPage;
